module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Gg1FGx/tc-custom/9781634866637.jpg?1723404860894",
      "alt": "This image is the cover for the book High Noon in Sandbridge"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("High Noon in Sandbridge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sequel to "), _c('i', [_vm._v("Daybreak in Sandbridge")]), _c('br'), _c('br'), _vm._v("Life is pretty good for Scooter and Andy Stahl-Howard these days. The restaurant is doing well and they’re happy with their little family."), _c('br'), _c('br'), _vm._v("Then Scooter’s sister meets an untimely end, and Scooter and Andy are suddenly guardians to a niece they’ve only met a handful of times. Their attempts to make a home for the bereaved child are complicated by Andy's mother, Scooter’s ex-lover, and the man who claims to be Billie’s father."), _c('br'), _c('br'), _vm._v("But whatever her parentage, Billie is a Stahl through and through -- stubborn and hot-tempered and not remotely interested in making a life in the one place her mother had sworn never to return. Will she ever learn to call Dockside and Sandbridge home?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth L. Brooks, Lynn Townsend\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0